import { StrictMode, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { AuthProvider } from 'react-oidc-context';
import './index.css';
import { initTheme } from './theme';
import { loadConfig, type AppConfig } from './config';
import { createUserManager } from './auth/oidc';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Logo } from './components/Logo';

function Root({ config }: { config: AppConfig }) {
  const navigate = useNavigate();
  const [userManager] = useState(() => createUserManager(config));
  return (
    <AuthProvider
      userManager={userManager}
      onSigninCallback={() => {
        // Successful code exchange on /auth/callback → land on the dashboard.
        navigate('/admin', { replace: true });
      }}
    >
      <App config={config} userManager={userManager} />
    </AuthProvider>
  );
}

async function bootstrap() {
  initTheme();

  const root = createRoot(document.getElementById('root')!);

  try {
    const config = await loadConfig();
    root.render(
      <StrictMode>
        <ErrorBoundary>
          <BrowserRouter>
            <Root config={config} />
          </BrowserRouter>
        </ErrorBoundary>
      </StrictMode>,
    );
  } catch (err) {
    console.error('Boot failed', err);
    root.render(
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 px-6 text-center">
        <Logo />
        <div>
          <h1 className="text-xl font-bold">Knocking Forms is temporarily unavailable</h1>
          <p className="mt-2 max-w-md text-sm text-muted">
            {err instanceof Error ? err.message : 'Unknown error'}. Please try again in a moment or contact IT.
          </p>
        </div>
      </div>,
    );
  }
}

void bootstrap();
